import { TrendingFeedPost } from "components";
import FeedLayout from "layouts/files/FeedLayout";
import { useState } from "react";
import { MapPagesHeader } from "ui";

const PlacesMap = () => {
    const [filter, setFilter] = useState("");
    return (
        <FeedLayout pageTitle="map">
            <div className="maps-pages">
                <MapPagesHeader
                    title="Places"
                    filterVal={filter}
                    setFilterVal={setFilter}
                />
                <TrendingFeedPost isHashtag={false} place="India" />
                <TrendingFeedPost
                    isHashtag={false}
                    place="Egypt"
                    text="please choose between the two options"
                    mediaType={8}
                />
                <TrendingFeedPost
                    isHashtag={false}
                    place="China"
                    mediaType={5}
                />
                <TrendingFeedPost isHashtag={false} place="USA" mediaType={9} />
            </div>
        </FeedLayout>
    );
};

export default PlacesMap;
